import { ButtonToolbar, Icon, IconButton } from "rsuite";
import { useState } from "react";

interface AllFiltersToggleProps {
  onToggle?: (open: boolean) => void;
}

const AllFiltersToggle = ({ onToggle }: AllFiltersToggleProps) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    const next = !open;
    setOpen(next);
    onToggle?.(next);
  };

  return (
    <ButtonToolbar className={`all-filter-btn ${open ? "opened" : "closed"}`}>
      <IconButton icon={<Icon icon="filter" />} onClick={handleClick}>
        All Filters
      </IconButton>
    </ButtonToolbar>
  );
};

export default AllFiltersToggle;
